module.exports = __webpack_public_path__ + "static/media/droplet-slash.12dbb7f7.svg";